<form
  autocomplete="off"
  novalidate
  (ngSubmit)="updatePassword(parentFormGroup.value)"
>
  <h1 mat-dialog-title class="mat-dialog-style m24">{{ "UpdatePassword" | localize }}</h1>
  <mat-dialog-content>
    <div [formGroup]="parentFormGroup">
      <div class="row">
        <div class="col-md-12">
          <mat-form-field>
            <input
              matInput
              id="currentPassword"
              type="password"
              name="CurrentPassword"
              formControlName="currentPassword"
              [placeholder]="'OldPassword' | localize"
              required
              minlength="2"
              maxlength="32"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-12"
          [formGroup]="passwordsFormGroup"
          formGroupName="passwords"
        >
          <mat-form-field>
            <input
              matInput
              id="newPassword"
              formControlName="newPassword"
              type="password"
              name="NewPassword"
              [placeholder]="'NewPassword' | localize"
              required
              minlength="4"
              maxlength="32"
            />
            <mat-error *ngIf="passwordsFormGroup.controls.newPassword.errors">
              {{ "PasswordsMustAtLeast4Char" | localize }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" formGroupName="passwords">
          <mat-form-field>
            <input
              matInput
              id="repeatNewPassword"
              formControlName="repeatNewPassword"
              type="password"
              name="RepeatNewPassword"
              [placeholder]="'RepeatNewPassword' | localize"
              [errorStateMatcher]="equalMatcher"
              required
              minlength="4"
              maxlength="32"
            />
            <mat-error
              *ngIf="
                passwordsFormGroup.errors &&
                passwordsFormGroup.errors.areEqual &&
                passwordsFormGroup.controls.newPassword.touched
              "
            >
              Şifreler eşleşmiyor.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <div mat-dialog-actions class="passw0rd24" color="primary" align="end">
      <button mat-stroked-button type="button" class="bgcw" (click)="close(false)">
        {{ "Cancel" | localize }}
      </button>
      <button mat-flat-button class="saveButton" type="submit" flex="15" color="primary"
      [disabled]="!parentFormGroup.valid || isLoading">
        {{ "Save" | localize }}
        <i class="fa fa-spin fa-spinner" *ngIf="isLoading"></i>
      </button>
    </div>
  </div>
</form>
